import { gql } from '@apollo/client';

export const GET_DEMO_VIDEOS = gql`
  query GetDemoVideos{
    listVideos(filter: { demo: 1 }) {
      id
      title
      url
      description
    }
  }
`;

export const GET_ALL_PATHWAYS = gql`
  query GetAllPathways{
    listPathways {
      name
      description
      image_url
    }
  }
`;

export const GET_ALL_AREAS = gql`
  query GetAllAreas{
    listBaseVideoCategories {
      id
      title
      image_url
      description
    }
  }
`;

export const GET_CATEGORIES_BY_PARENT = gql`
  query GetCategoriesByParent($parent_id: [ID]) {
    listVideoCategories(filter: { parent_id: $parent_id }) {
      id
      title
      image_url
      description
      slug
    }
  }
`;

export const GET_ALL_CATEGORIES = gql`
  query GetAllCategories{
    listVideoCategories {
      id
      title
      parent_id
    }
  }
`;

export const GET_VIDEO = gql`
  query GetVideoById($id: ID!) {
    getVideo(id: $id) {
      id
      title
      description
      preview_url
      video_url
      verse_video_url
      executive_summary
      summary
      key_learning_objectives {
        id
        title
      }
      duration
      created_at
      user {
        id
        name
        avatar
        description
      }
      categories {
        id
        title
        slug
      }
    }
  }
`;

export const GET_VIDEOS_BY_EXPERT = gql`
  query GetVideosByExpert($id: ID) {
    listVideos(filter: { user_id: [$id] }) {
      id
      title
      preview_url
      video_url
      duration
    }
  }
`;

export const GET_RELATED_VIDEOS = gql`
  query GetRelatedVideos($filter: VideoYouMightAlsoLikeFilter) {
    listVideosYouMightAlsoLike(filter: $filter) {
      id
      title
      duration
      preview_url
      video_url
      user {
        id
        name
        slug
      }
      difficulty {
        id
        icon_url
        title
      }
      categories {
        id
        title
        slug
        parent {
          slug
          id
        }
      }
      difficulty {
        id
        icon_url
        title
      }
    }
  }
`;

export const GET_CONTINUE_WATCHING_VIDEO_LINKS = gql`
  query GetContinueWatchingVideoLinks($filter: VideoContinueWatchingLinksFilter) {
    listContinuingWatchingLinks(filter: $filter) {
      time
      chapter
      url
      video {
        id
      }
    }
  }
`;

export const GET_NEXT_IN_PATHWAY_VIDEO = gql`
  query GetNextVideoInPathway($filter: VideoNextInPathwayFilter) {
    getVideoNextInPathway(filter: $filter) {
      id
      title
      duration
      preview_url
      video_url
      user {
        id
        name
        slug
      }
      categories {
        id
        title
        slug
        parent {
          slug
          id
        }
      }
      difficulty {
        id
        icon_url
        title
      }
      pathways {
        name
        slug
        id
        videos {
          id
          title
          video_url
          difficulty {
            id
            icon_url
            title
          }
        }
      }
    }
  }
`;

export const CHECK_IF_VIDEO_EXISTS_IN_WATCHLIST = gql`
  query CheckIfVideoExistsInWatchlist($filter: VideoExistsInWatchListFilter) {
    VideoExistsInUserWatchList(filter: $filter) {
      exists
    }
  }
`;

export const ADD_VIDEO_TO_WATCHLIST = gql`
  mutation AddVideoToWatchlist($input: VideoInWatchList) {
    AddVideoInWatchList(input: $input)
  }
`;

export const REMOVE_VIDEO_FROM_WATCHLIST = gql`
  mutation RemoveVideoFromWatchlist($input: VideoInWatchList) {
    DeleteVideoFromWatchList(input: $input)
  }
`;

export const GET_VIDEO_CATEGORY = gql`
  query GetVideoCategory($filter: UniqueVideoCategoryFilter!) {
    getVideoCategory(filter: $filter) {
      id
      image_url
      title
      description
      slug
      parent {
        id
        title
        slug
      }
    }
  }
`;

export const GET_VIDEO_BY_SLUG_OR_ID = gql`
  query GetVideoBySlugOrId($slug: [String], $id: [ID]) {
    listVideos(filter: { video_url: $slug, ids: $id }) {
      id
      title
      description
      preview_url
      video_url
      verse_video_id
      verse_video_url
      executive_summary
      summary
      show_bumper
      key_learning_objectives {
        id
        title
      }
      duration
      created_at
      user {
        id
        name
        avatar
        description
        slug
      }
      categories {
        id
        title
        slug
        parent {
          slug
          id
        }
      }
      difficulty {
        id
        icon_url
        title
      }
      pathways {
        id
        name
        slug
        videos {
          id
          video_url
          preview_url
          title
          duration
          user {
            id
            name
            avatar
            description
          }
          categories {
            id
            title
            slug
          }
          difficulty {
            id
            icon_url
            title
          }
        }
      }
    }
  }
`;

export const GET_VIDEO_BY_SLUG = gql`
  query GetVideoBySlug($slug: [String]) {
    listVideos(filter: { video_url: $slug }) {
      id
      created_at
    }
  }
`;

export const GET_VIDEO_PROGRESS_LIST = gql`
  query GetVideoProgressList($filter: VideoContinueWatchingLinksFilter) {
    listVideoProgress(filter: $filter) {
      time
      chapter
      completed
      last_position
      video {
        id
      }
    }
  }
`;

export const GET_RATING_FOR_ENTITY = gql`
  query GetListReviewsForEntity(
    $entity_type: ReviewableType!
    $entity_id: Int!
    $pagination_option: PaginationOption!
  ) {
    getListReviewsForEntity(
      entity_type: $entity_type
      entity_id: $entity_id
      pagination_option: $pagination_option
    ) {
      general_star_rating
    }
  }
`;

export const GET_LIST_REVIEWS_FOR_ENTITY = gql`
  query GetListReviewsForEntity(
    $entity_type: ReviewableType!
    $entity_id: Int!
    $pagination_option: PaginationOption!
  ) {
    getListReviewsForEntity(
      entity_type: $entity_type
      entity_id: $entity_id
      pagination_option: $pagination_option
    ) {
      general_star_rating
      count_reviews
      reviews {
        stars_rating
        created_at
        comment
        learner {
          first_name
          last_name
        }
      }
    }
  }
`;

export const CREATE_REVIEW = gql`
  mutation CreateReview($input: ReviewCreateInput!) {
    createReview(input: $input) {
      stars_rating
    }
  }
`;
